// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "../../theme/core.css";

// import required modules
import { Pagination, Navigation } from "swiper";

export default function ImageCarousel(props: any) {

    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
            >

                {props.imageArray.map((item: any, index: any) => {
                    console.log(item); return <SwiperSlide key={index}> <img src={item} alt=""  ></img></SwiperSlide>
                })}


            </Swiper>
        </>
    );
}

